import React, { Component } from 'react'
import {LegendComp} from '../components/legend/index';
import {LegendState, CHANGE_EVENT, TOGGLE_OPEN_EVENT} from './state';
//import { mapState, PADDING_SPACE_EVENT } from '../../state/map';
import { connect } from 'react-redux';
import PropTypes from 'prop-types'
import { recursiveLoop } from '../mapData/reducer';
import reducer from '../mobility/reducer';
import schoolMenuReducer from '../schoolMenu/reducer';
import {SchoolTypesState} from '../schoolTypes/state';
import studentsReducer from '../studentsMenu/reducer';
import { getActive as getActivePop } from '../population/reducer';

class Legend extends Component {

	constructor(props) {

		super(props);

		this.state = {
			open: this.props.enabled,
			data: [],
		}
	}

    getLegendData() {

        return this.props.data.concat(LegendState.get());
    }

	componentDidMount() {
		

		LegendState.on(CHANGE_EVENT, () => {

			this.setState({data: getLegendData()});
		});

		LegendState.on(TOGGLE_OPEN_EVENT, () => {
			this.setState({open: LegendState.getOpen()});
		});
	}

	toggleLegend() {


		LegendState.changeOpen();
	}

	render() {

		if(this.props.data.length === 0) {
			return null;
		}

	    return (
	    	<div style={{position: 'absolute', bottom: '0', right: ((48+this.props.leftOffset) + 'px')}}>
		        <LegendComp data={this.props.data} open={this.state.open} enabled={this.props.enabled} openHandler={this.toggleLegend.bind(this)} />
	      	</div>
	   	);
	}
}

Legend.propTypes = {
	data: PropTypes.array
};

const mapDispatchToPropsRes = (dispatch) => {

  return {
    clickItem: () => {
      
    }
  }
}

const mapStateToPropsRes = (state) => {

    var legendData = [];

    if(state.mapData.active) {

        recursiveLoop(state.mapData.data, (industry) => {

            if(industry.active && industry.color) {
              legendData.push({color: industry.color, text: industry.name});
            }

        });
	}


    //dev center
    if(reducer.getActiveIds(state.mobility).indexOf('dev_center_atta') > -1){

    	legendData = legendData.concat(
    		[{color: '#ffffff', text: '10 min'},
				{color: '#ffffe5', text: '20 min'},
				{color: '#ffeacb', text: '30 min'},
				{color: '#fed699', text: '40 min'},
				{color: '#ffad33', text: '50 min'},
				{color: '#d98c1a', text: '60 min'},
				{color: '#b36500', text: 'vairāk nekā 60 min'}]
			);
    	
    }

    if(reducer.getActiveIds(state.mobility).indexOf(2) > -1) {

    	legendData = legendData.concat(LegendState.createPubTransp());
    	
    }

 	//
 	 
	//quality indicators
 	var group = schoolMenuReducer.getActiveObject(state.schoolMenu)[0];

 	if(typeof group === 'object') {

 		if(typeof group.order === 'object') {
 			var data = [];		

		if(typeof group !== 'undefined' && typeof group.order !== 'undefined'){
			for (var i = group.order.length - 1; i >= 0; i--) {

				data.push({color: group.colors[i], text: group.order[i]});
			}
		}

		legendData = legendData.concat(data);
 		} else if (group.id == 'school_types') {

 			var schoolLegendData = LegendState.createSchoolTypesLegend(SchoolTypesState);
 			legendData = legendData.concat(schoolLegendData);
 		}
 		
 	}
 	//

	if(studentsReducer.getActiveIds(state.studentsMenu).indexOf('students_by_schools') > -1){

		if(typeof schoolLegendData == 'undefined') {
			var schoolLegendData = LegendState.createSchoolTypesLegend(SchoolTypesState);
	 			legendData = legendData.concat(schoolLegendData);
		}

		var schoolLegendStudentsData = LegendState.createSchoolTypesStudentsLegend(SchoolTypesState);

		legendData = legendData.concat(schoolLegendStudentsData);
	}


	if(getActivePop(state).length > 0) {

		legendData = legendData.concat(
			[{color: '#ff4f4f', text: '0 - 6 gadi'},
				{color: '#f49542', text: '7 - 18 gadi'},
				{color: '#7986cb', text: '19 - 62 gadi'},
				{color: '#636363', text: '63 gadi un vairāk'}]
			);
	}
 	
 	
    //quality
    return {
        leftOffset: state.map.padding[1],
        data: legendData,
        open: (legendData.length > 0 ? true : false),
        enabled: (legendData.length > 0 ? true: false)
    }
}

const Comp = connect(
  mapStateToPropsRes,
  mapDispatchToPropsRes
)(Legend);

export default Comp;


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/legend/container.js